module.exports = __webpack_public_path__ + "static/media/MOONBEAM.1fd6dbc6.svg";